import {
  type StoredUserPreferences,
  validateServicioSlug,
} from '~~/helpers/preferences';

export const determineRedirect = (
  servicioSlug: string | undefined,
  fullPath: string,
  isMitren: boolean,
  cookieServicio: string | undefined
): string | null => {
  // An explicit route slug that is not an allowed service falls back to the
  // base service so invalid deep links never render a broken page (existing
  // dual-site behavior, kept for existing tests).
  if (servicioSlug && !validateServicioSlug(servicioSlug)) {
    return isMitren ? '/' : '/biotren';
  }

  // Root redirect: only a *present, valid* saved service from the persisted
  // `mb_user` cookie is redirect-worthy. Absent, malformed, or unknown cookie
  // values fall through so new users stay on the index page. The slug is
  // validated against `ALLOWED_SERVICES_SLUG`, so the target is always a
  // known, safe `/${slug}` — never an arbitrary string from the cookie.
  if (fullPath.split(/[?#]/, 1)[0] === '/') {
    const savedServicio = validateServicioSlug(cookieServicio);
    if (savedServicio) {
      return `/${savedServicio}`;
    }
  }

  return null;
};

export default defineNuxtRouteMiddleware((to) => {
  const isMitren = useRuntimeConfig().public.mitren === true;
  // `useCookie` is SSR-safe: no `localStorage`/`document` access on the
  // server. The persisted value is untrusted and validated in
  // `determineRedirect`.
  const cookie = useCookie<StoredUserPreferences>('mb_user');
  const servicioSlug =
    typeof to.params.servicio === 'string' ? to.params.servicio : undefined;

  const redirect = determineRedirect(
    servicioSlug,
    to.fullPath,
    isMitren,
    cookie.value?.servicio ?? undefined
  );

  if (redirect) {
    return navigateTo(redirect);
  }
});
